export default {
  sazonais: [],
  sazonal: {}
}